import { useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { GuidedTour } from "./GuidedTour";
import { TourHelpButton } from "./TourHelpButton";
import { usePlatformTour } from "@/hooks/usePlatformTour";
import { homeTourSteps, campaignTourSteps, partnersTourSteps, influencersTourSteps, clientDashboardTourSteps, affiliateDashboardTourSteps } from "@/data/tourSteps";
import type { TourStep } from "./GuidedTour";

const TOUR_MAP: Record<string, { key: string; steps: TourStep[] }> = {
  "/": { key: "home", steps: homeTourSteps },
  "/campaign": { key: "campaign", steps: campaignTourSteps },
  "/client-dashboard": { key: "client_dashboard", steps: clientDashboardTourSteps },
  "/partners": { key: "partners", steps: partnersTourSteps },
  "/influencers": { key: "influencers", steps: influencersTourSteps },
  "/affiliate-dashboard": { key: "affiliate_dashboard", steps: affiliateDashboardTourSteps },
};

interface PageTourManagerProps {
  disabled?: boolean;
}

export const PageTourManager = ({ disabled = false }: PageTourManagerProps) => {
  const location = useLocation();
  const { language } = useLanguage();
  const tourConfig = TOUR_MAP[location.pathname];

  const { showTour, startTour, endTour } = usePlatformTour(tourConfig?.key || "none", !disabled);

  if (disabled) return null;

  if (!tourConfig) return <TourHelpButton onStartTour={() => {}} />;

  return (
    <>
      <GuidedTour
        steps={tourConfig.steps}
        isOpen={showTour}
        onClose={endTour}
        language={language}
      />
      <TourHelpButton onStartTour={startTour} />
    </>
  );
};
